import { render } from "./PageSectionList.vue?vue&type=template&id=6270dd36&scoped=true"
import script from "./PageSectionList.vue?vue&type=script&lang=js"
export * from "./PageSectionList.vue?vue&type=script&lang=js"

import "./PageSectionList.vue?vue&type=style&index=0&id=6270dd36&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6270dd36"]])

export default __exports__